<template>
    <div class="switch-product" :theme="theme">
        <h4 class="center">Select A Product</h4>
        <div class="products" v-if="products">
            <div class="product flex flex-align" @click="activate(product)" v-for="product of products" :key="product.id">
                <div class="product-name ff text-overflow">{{product.product_title}}</div>
                <div class="product-check" v-if="product.product_id === active.product_id"></div>
            </div>
            <div class="product redeem-product flex flex-align" @click="redeem">
                <div class="product-name ff">Redeem Code</div>
                <div class="product-arrow"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Redeem from '@/components/modals/Redeem.vue';

    export default {
        name: 'SwitchProduct',
        methods: {
            activate(product){
                if(product.product_id !== this.active.product_id){
                    this.$store.dispatch('products/activate', product).then(() => {
                        this.$router.push({name: 'product.contents', params: {product: product.product_slug}});
                    });
                }

                this.$emit('close');
            },
            redeem(){
                this.$emit('close');
                this.$modal.show(Redeem, {}, {width: 320, height: 'auto', classes: 'modal'});
            }
        },
        computed: {
            products(){
                return this.$store.state.products.all;
            },
            active(){
                return this.$store.getters.product;
            },
            theme(){
                return this.$store.state.theme.active;
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .switch-product
    {
        background: var(--modal-background-color);
        border-radius: 3px;
    }

    h4
    {
        font-weight: 500;
        padding: 10px;
        font-size: 14px;
        color: var(--secondary-text-color);
    }

    .product
    {
        border-top: 1px solid var(--border-color);
        padding: 15px;
        cursor: pointer;
        transition: background-color ease 0.2s;

        &:hover, &:active
        {
            background: var(--modal-background-color-hover);
        }
    }

    .product-name
    {
        font-size: 16px;
        color: var(--primary-text-color);
        line-height: 20px;
    }

    .product-membership
    {
        color: var(--secondary-text-color);
        line-height: 20px;
        text-transform: capitalize;
    }

    .product-check, .product-arrow
    {
        margin-left: 15px;
        background: url('~@/assets/icons/white/check.svg') 1px 3px no-repeat @base;
        background-size: 18px auto;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    .redeem-product
    {
        .product-name
        {
            color: @grey;
        }

        .product-arrow
        {
            background: url('~@/assets/icons/grey/plus.svg') center center no-repeat transparent;
            background-size: 24px auto;
            border-radius: 0;
        }
    }
</style>
